document.addEventListener(
    'alpine:init',
    () => {
        Alpine.data(
            'cirrus_events_block',
            ({ baseUrl, queryArgs }) => ({
                isLoading: true,
                isLoadingMore: false,
                events: [],
                perPage: queryArgs.per_page || 12,
                total: 0,
                totalPages: 0,
                baseUrl,
                queryArgs,
                init() {

                    this.$watch(
                        'queryArgs.page',
                        async () => {
                            this.isLoading = true;
                            await this.fetchEvents();
                        }
                    );

                    this.fetchEvents();
                },
                async fetchEvents() {
                    const response = await fetch(this.baseUrl + '?' + new URLSearchParams(this.queryArgs));
                    const { events, total, total_pages } = await response.json();
                    this.isLoading = false;
                    this.isLoadingMore = false;
                    this.events = events || [];
                    this.total = total;
                    this.totalPages = total_pages;
                },
                async loadMore() {
                    this.isLoadingMore = true;
                    this.queryArgs.per_page = this.events.length + this.perPage;
                    this.fetchEvents();
                },
                hasEvents() {
                    return this.events.length > 0;
                },
                hasMoreEvents() {
                    return this.queryArgs.page < this.totalPages;
                },
                currentPage() {
                    return this.queryArgs.page || 1;
                },
                prevPage() {
                    this.queryArgs.page -= 1;
                },
                nextPage() {
                    this.queryArgs.page += 1;
                },
                hasNextPage() {
                    return this.currentPage() < this.totalPages;
                },
                hasPreviousPage() {
                    return this.currentPage() > 1;
                }
            })
        );
    }
);